import { Claim } from "../../api/ClientFileApi";
import { isActiveClaim, sumCurrentSaldo } from "../utils/claimTotals";
import { useClientClaims } from "./useClientClaims";

export interface ActiveClaimsSummary {
  totalSaldo: number;
  count: number;
}

function summarize(claims: Claim[]): ActiveClaimsSummary {
  const activeClaims = claims.filter(isActiveClaim);

  return {
    totalSaldo: sumCurrentSaldo(activeClaims),
    count: activeClaims.length,
  };
}

export function useActiveClaimsSummary(clientId: string | undefined) {
  const { data } = useClientClaims(clientId, summarize);

  return data;
}
